/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Search,
  Filter,
  Download,
  ReportMoney,
  ClockHour4,
  CircleX,
  AlertCircle,
  TrendingUp,
  ArrowDownLeft,
  ArrowUpRight,
  ArrowsLeftRight,
  ArrowRight,
} from 'tabler-icons-react';
import {
  TextInput, Tooltip, useMantineColorScheme, Progress,
} from '@mantine/core';
import { Card, ConfigProvider } from 'antd';
import { assetPrefix, displayDateV2, renderNumber } from '../../../utilities/general';
import CustomSelect from '../../Listing/companyData/Select';
import styles from './PositionsTabV2.module.css';
import CircleCheck from '../../../components/CommonFunction/CircleCheck';

export default function TransfersTabV2(props) {
  const [searchValue, setSearchValue] = useState('');
  const { colorScheme } = useMantineColorScheme();

  const [selectTransferType, setSelectTransferType] = useState('All Types');
  const [selectTransferPlatform, setSelectTransferPlatform] = useState('All Platforms');

  const transferTypeClasses = {
    Deposit: {
      icon: <ArrowDownLeft size={16} color="#00BC7D" />,
      classes: 'border border-[#A4F4CF] text-[#009966] bg-[#ECFDF5]',
    },
    Withdrawal: {
      icon: <ArrowUpRight size={16} color="#FB2C36" />,
      classes: 'border border-[#FFC9C9] text-[#E7000B] bg-[#FEF2F2]',
    },
    Internal: {
      icon: <ArrowsLeftRight size={16} color="#2B7FFF" />,
      classes: 'border border-[#BEDBFF] text-[#0861C7] bg-[#EFF6FF]',
    },
  };

  const filterByType = [
    { value: 'All Types', label: 'All Types' },
    { value: 'Deposits', label: 'Deposits' },
    { value: 'Withdrawals', label: 'Withdrawals' },
    { value: 'Internal', label: 'Internal' },
    { value: 'Last 30 Days', label: 'Last 30 Days' },
  ];

  const filterByPlatform = [
    { value: 'All Platforms', label: 'All Platforms' },
    { value: 'Coinbase', label: 'Coinbase' },
    { value: 'Binance', label: 'Binance' },
    { value: 'Kraken', label: 'Kraken' },
  ];

  const transactionsData = [
    {
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png', // USDC
      asset: 'USDC',
      type: 'Deposit',
      from: 'Bank Account',
      to: 'Coinbase',
      amount: 5000.0,
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Coinbase',
    },
    {
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png', // Bitcoin
      asset: 'BTC',
      type: 'Withdrawal',
      from: 'Binance',
      to: 'Cold Wallet',
      amount: 0.15,
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Binance',
    },
    {
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png', // Ethereum
      asset: 'ETH',
      type: 'Internal',
      from: 'Spot',
      to: 'Margin',
      amount: 2.5,
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Kraken',
    },
    {
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png', // Solana
      asset: 'SOL',
      type: 'Deposit',
      from: 'External Wallet',
      to: 'Binance',
      amount: 50.0,
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Binance',
    },
    {
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png', // USDT
      asset: 'USDT',
      type: 'Withdrawal',
      from: 'Coinbase',
      to: 'Bank Account',
      amount: 2500.0,
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Coinbase',
    },
    {
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2010.png', // Cardano
      asset: 'ADA',
      type: 'Deposit',
      from: 'Staking Wallet',
      to: 'Kraken',
      amount: 1000.0,
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Kraken',
    },
    {
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6636.png', // Polkadot
      asset: 'DOT',
      type: 'Internal',
      from: 'Spot',
      to: 'Staking',
      amount: 75.5,
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Kraken',
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            bodyPadding: 16,
            borderRadiusLG: 14,
          },
        },
      }}
    >
      <div>
        <div className="flex flex-col gap-6 mx-auto">
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold text-[#101828] dark:text-white">Transfers</h1>
            <p className="text-base font-normal text-[#4A5565] dark:text-[#898989]">Track your deposits, withdrawals, and internal transfers</p>
          </div>
          <div className="grid grid-cols-4 gap-4">
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="flex items-center gap-2 text-sm text-[#4A5565] dark:text-[#898989]">
                <TrendingUp size={16} color="#6A7282" />
                <span>Total Transfers</span>
              </div>
              <div className="text-2xl font-bold text-[#101828] dark:text-[#BEB9B9]">
                7
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="flex items-center gap-2 text-sm text-[#4A5565] dark:text-[#898989]">
                <ArrowDownLeft size={16} color="#00BC7D" />
                <span>Deposits</span>
              </div>
              <div className="text-2xl font-bold text-[#009966]">
                3
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="flex items-center gap-2 text-sm text-[#4A5565] dark:text-[#898989]">
                <ArrowUpRight size={16} color="#FB2C36" />
                <span>Withdrawals</span>
              </div>
              <div className="text-2xl font-bold text-[#E7000B]">
                2
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="flex items-center gap-2 text-sm text-[#4A5565] dark:text-[#898989]">
                <ArrowsLeftRight size={16} color="#2B7FFF" />
                <span>Internal</span>
              </div>
              <div className="text-2xl font-bold text-[#0861C7]">
                2
              </div>
            </Card>
          </div>
          <div className="flex flex-col items-start gap-[46px] rounded-[14px] bg-white dark:bg-[#26282C] p-6 shadow-md flex-shrink-0 self-stretch">
            <div className="w-full flex justify-between items-center">
              <div className="h-9 flex justify-center items-start gap-4">
                <TextInput
                  classNames={{
                    input: 'bg-[#FAFAFA] dark:bg-[#1a1b1e] dark:border-neutral-600 border-[#E5E7EB]',
                  }}
                  className="w-80"
                  placeholder="Search transfers..."
                  radius="md"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.currentTarget.value)}
                  icon={<Search size={16} color="#99A1AF" />}
                />
                <CustomSelect
                  options={filterByType}
                  value={selectTransferType}
                  onChange={setSelectTransferType}
                  icon={<Filter size={16} color="#717182" />}
                />
                <CustomSelect
                  options={filterByPlatform}
                  value={selectTransferPlatform}
                  onChange={setSelectTransferPlatform}
                />
              </div>
              <div className={`${styles.padding} border border-[#0000001A] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-lg`}>
                <Download size={16} color={colorScheme === 'dark' ? '#898989' : '#0A0A0A'} />
                <span className="text-sm font-medium text-[#0A0A0A] dark:text-[#898989]">Export</span>
              </div>
            </div>
            <div className={`${styles.grid} w-full h-full flex flex-col items-start border border-[#F3F4F6] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-[10px]`}>
              <div className={`w-full h-10 grid items-center p-2 rounded-t-lg border-b border-[#0000001A] bg-[#F9FAFB80] dark:border-neutral-600 dark:bg-[#1a1b1e] ${styles.TransfersTabHeadingGrid}`}>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Asset
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Type
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  To/From
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Amount
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Timestamp
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Platform
                </div>
              </div>
              {transactionsData.map((items) => {
                const { icon, classes } = transferTypeClasses[items.type];
                return (
                  <div className={`w-full h-[73px] grid items-center p-2 rounded-t-lg border-b border-[#0000001A] dark:border-neutral-600 last:border-none ${styles.TransfersTabRowGrid}`}>
                    <div className="flex items-center gap-3 text-base font-normal">
                      {items?.icon
                        ? (
                          <img
                            className="w-8 h-8 rounded-full"
                            src={items?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                            alt="Crypto"
                          />
                        )
                        : <ReportMoney className="w-11 h-11" />}

                      <div className="flex items-center">
                        <span
                          className={`${styles.title} font-semibold text-[#101828] dark:text-[#898989]`}
                        >
                          {items?.asset?.length > 10 ? `${items?.asset?.slice(0, 8)}...` : items?.asset.toUpperCase() || '-'}
                        </span>
                      </div>
                    </div>
                    <div className="w-fit flex items-center text-xs gap-2 font-medium">
                      {icon && icon}
                      <span className={`py-0.5 px-2 rounded-lg ${classes}`}>{items.type}</span>
                    </div>
                    <div className={`flex items-center gap-1 ${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                      <span>{items.from}</span>
                      <ArrowRight size={16} color={colorScheme === 'dark' ? '#898989' : '#101828'} />
                      <span>{items.to}</span>
                    </div>
                    <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                      {`${renderNumber(items?.amount)} ${items?.asset.toUpperCase()}`}
                    </div>
                    <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                      {displayDateV2(items.timeStamp)}
                    </div>
                    <div className="text-xs w-fit font-medium rounded-lg py-1 px-2 border bg-[#F9FAFB] text-[#0A0A0A] border-[#0000001A]">
                      {items?.platform}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}
